"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ForgotPasswordPage = void 0;
const react_1 = __importStar(require("react"));
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const doshx_controls_web_1 = require("doshx_controls_web");
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const routes_1 = require("../../../constants/routes");
const validateForm_1 = require("../../../helpers/validateForm/validateForm");
const constants_1 = require("../../../constants/constants");
const main_1 = require("../../../reducers/slices/main");
const forgot_password_1 = require("../../../api/calls/user/forgot_password");
const ForgotPasswordPage = () => {
    const dispatch = (0, react_redux_1.useDispatch)(); //<AppDispatch>
    const navigate = (0, react_router_dom_1.useNavigate)();
    const { user, isLoading } = (0, react_redux_1.useSelector)((state) => state.userState);
    const [credentials, setCredentials] = (0, react_1.useState)({ email: "" });
    const { errors, isValid } = (0, validateForm_1.validateForm)(credentials);
    const _setCredentials = (value) => {
        setCredentials(Object.assign(Object.assign({}, credentials), value));
    };
    const showLoader = () => {
        dispatch((0, main_1.setContentModal)({
            title: "Please Wait...",
            content: react_1.default.createElement(doshx_controls_web_1.CircularLoaderControl, { size: "small" }),
        }));
    };
    const handleResponse = (response) => {
        if (response.success) {
            dispatch((0, main_1.setContentModal)({ title: "Success", content: react_1.default.createElement(react_1.default.Fragment, null, response.message) }));
            navigate(`${routes_1.WELCOME_ROUTE}${routes_1.OTP_ROUTE}/${response.content._id}`);
        }
        else
            dispatch((0, main_1.setContentModal)({ title: constants_1.REQUEST_ERROR_TITLE, content: react_1.default.createElement(react_1.default.Fragment, null, response.message) }));
    };
    const _onSubmit = () => __awaiter(void 0, void 0, void 0, function* () {
        const { email } = credentials;
        showLoader();
        const response = yield (0, forgot_password_1.forgot_password)({
            email,
        });
        handleResponse(response);
    });
    return (react_1.default.createElement("div", { className: "flex flex-col gap-y-4 h-full justify-center w-full lg:w-[700px] py-4 lg:py-0 px-4 lg:px-20" },
        react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Forgot password?", size: "3xlarge", bold: true, textColor: "text-black" }),
        react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Enter the email address you used when you joined and we'll send you instructions to reset your password", textColor: "text-black", size: "small" }),
        react_1.default.createElement("div", { className: "w-full flex flex-col gap-y-4" },
            react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Email", type: "text", value: credentials.email, errorText: errors.email, borderColor: "border-borders", onChange: (email) => {
                    _setCredentials({ email });
                } }),
            react_1.default.createElement("div", { className: "grid" },
                react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Submit", enabled: isValid, loading: isLoading, backgroundColor: "bg-primary", onClick: _onSubmit }))),
        react_1.default.createElement("div", { className: "flex flex-row justify-between items-center" },
            react_1.default.createElement(doshx_controls_web_1.LinkButtonControl, { textColor: "text-blue-500", iconColor: "text-blue-500", size: "medium", icon: pro_solid_svg_icons_1.faChevronLeft, label: "Back to sign in", iconSide: "left", onClick: () => {
                    navigate(`${routes_1.WELCOME_ROUTE}${routes_1.LOG_IN_ROUTE}`);
                } }))));
};
exports.ForgotPasswordPage = ForgotPasswordPage;
